<template>
  <div>
    <!-- Asia Access -->
    <div class="asia">
      <!-- <div class="title" v-if="this.$route.path!='/'">{{currentLanguage==1?"链接亚洲":"Asia Access"}}</div> -->
      <!-- <div class="hxa" v-if="this.$route.path!='/'"><img src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/webLogoEN.png" alt="" class="holden"> X <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/appa/APPA.png" alt=""></div> -->
      <div class="value">
        <!-- 消费者 -->
        <div class="consumer" v-show="showIndex===0&&isshow">
          <div class="pointChina">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/physicians_China.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointTaiwan">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/physicians_Taiwan PRC.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointHongkong">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/physicians_Hong Kong PRC.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointJapan">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/physicians_Japan.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointKorea">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/physicians_Korea.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointIndia">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/physicians_India.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointIndonesia">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/physicians_Indonesia.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- <div class="pointMalaysia">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="@/assets/img/panel/HCP-China.png" style="width:200px">Malaysia</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->

          <!-- <div class="pointSingapore">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="@/assets/img/panel/HCP-China.png" style="width:200px">Singapore</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->

          <div class="pointThailand">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/physicians_Thailand.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointPhilippnes">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/physicians_Philippines.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- <div class="pointVietnam" >
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="@/assets/img/panel/HCP-China.png" style="width:200px">Vietnam</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
        </div>

        <!-- 医生 -->
        <div class="Physician" v-show="showIndex===1&&isshow">
          <div class="pointChina">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/patients_China.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointJapan">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/solutions/patients_Japan.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- <div class="pointTaiwan">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Taiwan</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointHongkong">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Hong Kong</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointJapan">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Japan</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointKorea">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Korea</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointIndia">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>India</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointIndonesia">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Indonesia</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointMalaysia">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Malaysia</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointSingapore">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Singapore</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointThailand">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Thailand</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointPhilippnes">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Philippnes</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointVietnam">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div>Vietnam</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
        </div>

        <!-- 消费者 -->
        <div class="Consumer" v-show="showIndex===2&&isshow">
          <div class="pointChina">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown" style="padding:0">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-China.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointTaiwan">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-TaiWan.png" style="width:200px">Taiwan</div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointHongkong">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-HongKong.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointJapan">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-Japan.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointKorea">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-Korea.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointIndia">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-India.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointIndonesia">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-Indonesia.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointMalaysia">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-Malaysia.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointSingapore">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-Singapore.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointThailand">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-Thailand.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointPhilippnes">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-Philippnes.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="pointVietnam">
            <el-dropdown>
              <span class="el-dropdown-link">
                <div class="dotted"></div>
                <div class="pulse"></div>
                <div class="pulse1"></div>
                <div class="pulse2"></div>
                <div class="pulse3"></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/panel/consumer-Vietnam.png" style="width:200px"></div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div class="button">
          <!-- <div><button @click="show(0)" :class="showIndex==0?'active':''">consumer</button><button class="second" v-show="showIndex===0&&isshow" ><a href="/Holden APAC consumer panel book 2022.pdf" download="holden APAC consumer panel book 2022.pdf" class="down">Panel Book</a></button></div> -->
          <el-button type="primary" plain @click="show(0)">{{currentLanguage==1?"医生":"Physicians"}}</el-button>
          <el-button type="primary" plain @click="show(1)">{{currentLanguage==1?"患者":"Patients"}}</el-button>
          <el-button type="primary" plain @click="show(2)">{{currentLanguage==1?"消费者":"Consumer"}}</el-button>
        </div>

        <!-- 弹框 -->

        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Homepage/holden_map_001.png" onclick="return false">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showIndex: 0,
      isshow: true
    };
  },
  computed: {
    currentLanguage() {
      return Number(this.$store.state.lang);
    }
  },
  methods: {
    show(ind) {
      this.showIndex = ind;
      console.log(this.showIndex);
      // this.show=true
    }
  }
};
</script>

<style lang="scss" scoped>
.asia {
  position: relative;
  overflow: hidden;
  .title {
    padding: 50px 120px 0 120px;
    font-size: 40px;
    font-weight: 700;
    color: #003c50;
  }
  .hxa {
    position: absolute;
    top: 0%;
    right: 10%;
    img {
      width: 100px;
    }
    .holden {
      width: 150px;
    }
  }
  .value {
    margin: 0 auto;
    // width: 70%;
    position: relative;

    .button {
      position: absolute;
      // right: -30px;
      top: 20px;
      right: 10px;
      display: flex;

      .active {
        color: #000;
      }
      div {
        margin: 15px;
        display: flex;
        flex-direction: column;

        button {
          // width: 140px;
          background-color: #2cb1e9;
          border: none;
          padding: 10px;
          border-radius: 10px;
          color: #fff;
        }
        .second {
          background-color: #54ea7d;
        }
      }
    }
    .consumer {
      img {
        width: 100px;
      }
    }
    @keyframes warn1 {
      0% {
        transform: scale(0.3);
        -webkit-transform: scale(0.3);
        opacity: 0;
      }
      25% {
        transform: scale(0.3);
        -webkit-transform: scale(0.3);
        opacity: 0.1;
      }
      50% {
        transform: scale(0.3);
        -webkit-transform: scale(0.3);
        opacity: 0.3;
      }
      75% {
        transform: scale(0.5);
        -webkit-transform: scale(0.5);
        opacity: 0.5;
      }
      100% {
        transform: scale(0.8);
        -webkit-transform: scale(0.8);
        opacity: 0;
      }
    }
    .pointChina {
      position: absolute;
      top: 30%;
      left: 48%;
      width: 10px;
      height: 10px;
    }
    .pointTaiwan {
      position: absolute;
      top: 44%;
      left: 59%;
      width: 10px;
      height: 10px;
    }
    .pointHongkong {
      position: absolute;
      top: 46%;
      left: 54%;
      width: 10px;
      height: 10px;
    }
    .pointJapan {
      position: absolute;
      top: 27%;
      left: 68%;
      width: 10px;
      height: 10px;
    }
    .pointKorea {
      position: absolute;
      top: 26%;
      left: 60%;
      width: 10px;
      height: 10px;
    }
    .pointIndia {
      position: absolute;
      top: 50%;
      left: 30%;
      width: 10px;
      height: 10px;
    }
    .pointIndonesia {
      position: absolute;
      top: 77%;
      left: 56%;
      width: 10px;
      height: 10px;
    }
    .pointMalaysia {
      position: absolute;
      top: 70%;
      left: 47%;
      width: 10px;
      height: 10px;
    }
    .pointSingapore {
      position: absolute;
      top: 74%;
      left: 48%;
      width: 10px;
      height: 10px;
    }
    .pointThailand {
      position: absolute;
      top: 54%;
      left: 46%;
      width: 10px;
      height: 10px;
    }
    .pointPhilippnes {
      position: absolute;
      top: 58%;
      left: 61%;
      width: 10px;
      height: 10px;
    }
    .pointVietnam {
      position: absolute;
      top: 53%;
      left: 53%;
      width: 10px;
      height: 10px;
    }
    .dotted {
      position: absolute;
      width: 8px;
      height: 8px;
      top: -4px;
      left: -4px;
      border: 1px solid #f56c6c;
      background-color: #f56c6c;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      z-index: 1;
    }
    /* 产生动画（向外扩散变大）的圆圈 第一个圆 */
    .pulse {
      position: absolute;
      width: 100px;
      height: 100px;
      left: -50px;
      top: -50px;
      border: 1px solid #f56c6c;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      z-index: 1;
      opacity: 0;
      animation: warn1 2s linear 1s infinite;
      box-shadow: inset 1px 1px 30px #f56c6c; /* 阴影效果 */
    }
    /* 产生动画（向外扩散变大）的圆圈 第二个圆 */
    .pulse1 {
      position: absolute;
      width: 100px;
      height: 100px;
      left: -50px;
      top: -50px;
      border: 1px solid #f56c6c;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      z-index: 1;
      opacity: 0;
      animation: warn1 2s linear 1s infinite;
      box-shadow: inset 1px 1px 30px #f56c6c; /* 阴影效果 */
    }
    .pulse2 {
      position: absolute;
      width: 100px;
      height: 100px;
      left: -50px;
      top: -50px;
      border: 1px solid #f56c6c;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      z-index: 1;
      opacity: 0;
      animation: warn1 2s linear 1s infinite;
      box-shadow: inset 1px 1px 30px #f56c6c; /* 阴影效果 */
    }
    .pulse3 {
      position: absolute;
      width: 100px;
      height: 100px;
      left: -50px;
      top: -50px;
      border: 1px solid #f56c6c;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      z-index: 1;
      opacity: 0;
      animation: warn1 2s linear 2s infinite;
      box-shadow: inset 1px 1px 30px #f56c6c; /* 阴影效果 */
    }
    img {
      width: 100%;
      height: 750px;
    }
  }
}

@media screen and (max-width: 576px) {
  .asia {
    .title {
      font-size: 80px;
    }
    .value {
      width: 100%;
      margin-bottom: 200px;
      .button {
        right: 20px;
        top: 900px;
      }
      img {
        height: 900px;
      }
    }
  }
  .asia {
    .value {
      .dotted {
        width: 40px;
        height: 40px;
        opacity: 0.8;
        left: -20px;
        top: -20px;
      }
      .pulse {
        width: 200px;
        height: 200px;
        left: -100px;
        top: -100px;
      }
      .pulse2 {
        width: 200px;
        height: 200px;
        left: -100px;
        top: -100px;
      }
      .pulse3 {
        width: 200px;
        height: 200px;
        left: -100px;
        top: -100px;
      }
    }
  }
}
</style>
<style>
.el-button {
  font-size: 16px;
}
@media screen and (max-width: 576px) {
  .el-button {
    font-size: 70px;
  }
}
</style>